import React from "react";

import { Modal } from "antd";

const ModalPopUp = props => {
  return (
    <div>
      <Modal
        title={props.title}
        visible={props.modalVisible}
        onOk={() => props.onModalOk(props.plan)}
        onCancel={props.onCancelModal}
      >
        {props.message}
      </Modal>
    </div>
  );
};

export default ModalPopUp;
